module.exports = __webpack_public_path__ + "img/user-added.006e17b0.png";